import { FormLabel as MuiFormLabel, formLabelClasses as muiFormLabelClasses, } from '@mui/material';
export const FormLabel = MuiFormLabel;
export const formLabelClasses = muiFormLabelClasses;
